const zh: Record<string, string> = {
  // Top navigation
  'nav.file': '文件',
  'nav.examples': '场景库',
  'nav.help': '帮助',
  'nav.community': '加入社区',
  'nav.support': '支持',

  // File dropdown
  'file.save': '保存',
  'file.saveLocal': '下载到本地',
  'file.open': '加载',
  'file.clearScene': '清空',

  // Edit mode
  'editMode.scene': '场景编辑',
  'editMode.animation': '动画编辑',

  // Language switcher
  'lang.label': '中 / EN',
  'lang.zh': '中文',
  'lang.en': 'English',

  // User menu
  'user.vip': 'VIP',
  'user.credits': '积分',
  'user.currentCredits': '当前积分：',
  'user.vipTitle': '尊贵VIP会员',
  'user.vipExpire': '到期：',
  'user.vipRemaining': '（剩',
  'user.vipDays': '天）',
  'user.founderPrice': '创始用户价',
  'user.vipPrice': '¥36',
  'user.vipPriceUnit': '/月',
  'user.creditsUnit': '点',
  'user.joinGroup': '添加微信群，获得',
  'user.joinGroupCredits': '积分',
  'user.buyCredits': '购买积分',
  'user.upgradePro': '购买专业版权益',
  'user.logout': '退出',
  'app.brandName': '摄影棚',
  'user.aiCreditsLabel': 'AI点数',
  'user.login': '登录',

  // Left panel toolbar
  'panel.layout': '布局图',
  'panel.importModel': '导入模型',
  'panel.aiImageToModel': 'AI图生模型',
  'panel.objectList': '对象列表',

  // Right panels
  'panel.panorama': '全景图',
  'panel.environment': '环境',
  'panel.cameraLabel': '摄像机：',
  'panel.aiGeneration': 'AI渲染',
  'panel.exportImage': '导出图片',
  'panel.addCameraHint': '请至少在场景中添加一个摄像机',
  'scene.exitGroupEdit': '退出组编辑',

  // Object list
  'obj.lockSuccess': '锁定成功',
  'obj.unlockSuccess': '解锁成功',
  'obj.lockedHint': '锁定成功。如想重新编辑，请去[对象列表]解锁。',

  // Property edit panel
  'prop.boneEdit': '骨骼姿势编辑',

  // Bone pose editor
  'bone.more': '更多',
  'bone.exportContent': '导出内容',
  'bone.currentFrame': '当前帧',
  'bone.wholeAnimation': '整个动画',
  'bone.applyScope': '应用范围',
  'bone.fullBody': '全身',
  'bone.upperBody': '上半身',
  'bone.lowerBody': '下半身',
  'bone.head': '头部',
  'bone.leftArm': '左臂',
  'bone.rightArm': '右臂',
  'bone.apply': '应用',
  'bone.allAnimations': '所有动画',
  'bone.playFailed': '播放动画失败',
  'prop.moveToGroup': '移动到组',
  'prop.lock': '锁定',
  'prop.unlock': '解锁',
  'prop.copy': '复制',
  'prop.editGroup': '编辑组',
  'prop.delete': '删除',

  // Sidebar (ObjTypeSelect)
  'sidebar.add': '添加',
  'sidebar.recent': '最近使用：',
  'sidebar.myAssets': '个人素材库',
  'sidebar.manageAssets': '管理素材库',
  'sidebar.contactSupport': '联系售后添加',
  'sidebar.within24h': '（24小时内添加）',
  'sidebar.userUpload': '用户上传',
  'sidebar.free': '(免费)',
  'sidebar.initScheme': '初始化方案',

  // Add guide bubble
  'guide.addModelTitle': '添加模型到场景中',
  'guide.addModelDesc': '点击左侧「添加」按钮，从分类列表中选择一个模型开始创作',
  'guide.gotIt': '知道了',
  'guide.close': '关闭引导',

  // Welcome / Template modal
  'welcome.title': '欢迎来到「摄影棚」，请选择创建场景的模板',
  'welcome.newEmpty': '新建空场景',
  'welcome.openFile': '加载文件',
  'welcome.myScenes': '我的场景',
  'welcome.officialScenes': '官方场景',
  'welcome.sceneNamePlaceholder': '请输入场景名称',

  // Export image modal
  'export.title': '导出图片',
  'export.standard': '标准',
  'export.hd': '高清',
  'export.ultraHd': '超清',
  'export.customWidth': '自定义宽度',
  'export.export': '导出',
  'export.pro': '专业版',

  // Common
  'common.cancel': '取消',
  'common.confirm': '确定',
  'common.close': '关闭',
  'common.loading': '加载中...',
  'common.none': '无',
  'common.noTexture': '无纹理',
  'common.editTexture': '编辑纹理',
  'common.allMaterials': '所有材质',
  'common.selectType': '请选择类型',
  'common.allTypes': '所有类型',
  'common.delete': '删除',
  'common.yes': '是',
  'common.no': '否',
  'common.saveSuccess': '保存成功',
  'common.saveFail': '保存失败',
  'common.loadFail': '加载失败',
  'common.saving': '保存中...',

  // Angle editor
  'angle.radian': '弧度：',
  'angle.angle': '角度：',

  // Environment editor
  'env.title': '环境设置',

  // Ground texture editor
  'gtexture.props': '属性',
  'gtexture.bg': '背景',
  'gtexture.save': '保存',
  'gtexture.saveScale': '保存({0}X)',
  'gtexture.clear': '清空',
  'gtexture.back': '返回',
  'gtexture.deleteElement': '删除元素',
  'gtexture.moveUp': '上移一层',
  'gtexture.moveDown': '下移一层',
  'gtexture.hintPolygon': '点击画布添加顶点，双击完成绘制（至少3点），按Esc取消',
  'gtexture.hintPolyline': '点击画布添加点，双击完成绘制（至少2点），按Esc取消',

  // Hunyuan 3D tasks
  'hunyuan.generating': '模型生成中',
  'hunyuan.useModel': '使用模型',
  'hunyuan.moveToLibrary': '迁移到个人素材库并使用',
  'hunyuan.moveSuccess': '迁移成功',
  'hunyuan.deleteConfirm': '确定要删除这个任务以及模型吗？',
  'hunyuan.deleteSuccess': '删除成功',

  // File / model operations
  'file.downloadFailed': '文件下载失败，请重试',
  'file.formatUnsupported': '请上传 FBX、OBJ 或 GLB 格式的文件',
  'file.emptyFile': '文件 "{0}" 大小为 0 字节，请检查文件是否损坏或为空',
  'file.tooLarge': '文件 "{0}" 太大（{1} MB），请上传小于 {2}MB 的文件',
  'file.processFailed': '文件处理失败，请重试',
  'file.buyModelConfirm': '是否购买该模型？需要消耗',
  'file.buyModelCredits': '积分',
  'file.buySuccess': '购买成功',
  'file.buyFailed': '购买失败',

  // Payment result page
  'payResult.verifying': '正在验证支付状态...',
  'payResult.successTitle': '购买成功',
  'payResult.successDesc': '您的订单已成功支付，感谢您的支持！',
  'payResult.orderNo': '订单号：',
  'payResult.closePage': '关闭页面',
  'payResult.failureTitle': '支付验证失败',
  'payResult.retry': '重新验证',
  'payResult.missingOrderNo': '缺少订单号参数',
  'payResult.verifyFailed': '支付状态验证失败',
  'payResult.networkError': '网络请求失败，请稍后重试',

  // Scene / drawing operations
  'scene.world': '世界',
  'scene.exitDrawing': '退出绘制',
  'scene.pleaseLogin': '请先登录',
  'scene.lockedObjWarn': '锁定对象不能编辑，请去[对象列表]解锁',
  'scene.clearConfirm': '确定要清空所有绘制内容吗？',
  'scene.logoutConfirm': '确定要退出登录吗？',

  // Edit panel labels
  'edit.messageLabel': '提示信息',
  'edit.messageFontSize': '提示信息字号',

  // Image edit panel
  'imgEdit.url': '网址',
  'imgEdit.file': '选择文件',
  'imgEdit.urlPlaceholder': '请输入网址',
  'imgEdit.upload': '上传文件',
  'imgEdit.historyTitle': '选择历史图片',
  'imgEdit.historyEmpty': '暂无历史图片',
  'imgEdit.existingImages': '已有图片',
  'imgEdit.more': '更多',
  'imgEdit.deleteConfirm': '确定要删除这张图片吗？',
  'imgEdit.deleteFailed': '删除失败，请重试',

  // Login / Register / Forgot password
  'login.close': '关闭',
  'login.title': '登录',
  'login.subtitle': '完成登录后，你的场景将自动保存。',
  'login.email': '邮箱',
  'login.password': '密码',
  'login.passwordPlaceholder': '请输入密码',
  'login.forgot': '忘记密码？',
  'login.submit': '登录并保存',
  'login.noAccount': '还没有账户？',
  'login.signup': '注册',
  'register.title': '注册账号',
  'register.subtitle': '注册后，你的场景将自动保存。',
  'register.confirmPassword': '确认密码',
  'register.passwordPlaceholder': '请输入密码（至少6位）',
  'register.confirmPlaceholder': '请再次输入密码',
  'register.captcha': '验证码',
  'register.captchaPlaceholder6': '请输入6位验证码',
  'register.captchaPlaceholder8': '请输入8位验证码',
  'register.sendCode': '发送验证码',
  'register.resendIn': '秒后重发',
  'register.haveAccount': '已有账号？',
  'register.loginNow': '立即登录',
  'register.submit': '注册',
  'forgot.title': '重置密码',
  'forgot.subtitle': '通过邮箱验证码重置你的登录密码。',
  'forgot.newPassword': '新密码',
  'forgot.newPasswordPlaceholder': '请输入新密码（至少6位）',
  'forgot.submit': '重置密码',
  'forgot.remember': '想起密码了？',

  // Form validation
  'form.confirmPassword': '请确认密码',
  'form.passwordMismatch': '两次输入的密码不一致',
  'form.enterCaptcha': '请输入验证码',
  'form.captchaLength': '验证码必须是',
  'form.captchaDigits': '位数字',
  'form.enterEmail': '请输入邮箱',
  'form.validEmail': '请输入有效的邮箱地址',
  'form.enterPassword': '请输入密码',
  'form.passwordMin': '密码长度至少为6位',

  // AI Image to 3D Model
  'ai3d.title': 'AI图生模型',
  'ai3d.genProgress': '生成进度',
  'ai3d.submitResult': '提交结果',
  'ai3d.jobId': 'Job ID：',
  'ai3d.uploadImage': '上传图片',
  'ai3d.uploadHint': '点击或拖拽上传图片',
  'ai3d.formatHint': '支持 JPG / PNG 等常见格式',
  'ai3d.reupload': '重新上传',
  'ai3d.submitting': '提交中...',
  'ai3d.generating': '生成中...',
  'ai3d.submitBtn': '开始生成模型(25积分)',
  'ai3d.taskList': '生成模型任务',
  'ai3d.refresh': '刷新',
  'ai3d.submittingWait': '正在提交中，请稍候...',
  'ai3d.uploadImageFile': '请上传图片文件',
  'ai3d.genSuccess': '模型生成成功',
  'ai3d.generatingModel': '正在生成模型...',
  'ai3d.queryTimeout': '查询超时，任务可能仍在处理中',
  'ai3d.taskSubmitted': '任务已提交，正在生成模型...',
  'ai3d.submitSuccess': '任务提交成功，正在生成模型',
  'ai3d.submitFailed': '提交失败',
  'ai3d.submitFailedRetry': '提交失败，请稍后重试',

  // VIP / Pro modal
  'vip.title': '解锁专业版',
  'vip.choosePlan': '选择套餐',
  'vip.priceLocked': '(价格锁定12个月)',
  'vip.recommend': '推荐',
  'vip.daysBenefits': '尊享',
  'vip.daysBenefits2': '天专业版权益',
  'vip.includes': '包含',
  'vip.credits': '积分',
  'vip.benefits': '专业版权益',
  'vip.payMethod': '支付方式',
  'vip.checking': '正在验证支付状态...',
  'vip.unpaid': '支付未完成',
  'vip.retry': '重新验证',
  'vip.cancel': '取消',
  'vip.paySuccess': '专业版权益购买成功！',
  'vip.planTitle.monthly': '月卡',
  'vip.planTitle.yearly': '年卡',
  'vip.priceUnit.monthly': '月',
  'vip.priceUnit.yearly': '年',

  // 双十一活动
  'double11.tag': '摄影棚 · 双十一特别活动',
  'double11.title': '购买1个月 Pro，额外赠送1个月',
  'double11.date': '活动截止至 2026 年 11 月 30 日',
  'double11.cta': '立即升级 Pro →',

  // Buy Credits / Pay modal
  'pay.title': '购买 AI 点数',
  'pay.subtitle': '用于 AI 场景生成及其他 AI 功能。',
  'pay.currentCredits': '当前 AI 点数',
  'pay.recommend': '推荐',
  'pay.afterPurchase': '购买后',
  'pay.balance': '余额',
  'pay.buyNow': '立即购买',
  'pay.footer': '点数不过期 · 一次购买，持续使用',
  'pay.credits': '点',
  'pay.checking': '正在验证支付状态...',
  'pay.unpaid': '支付未完成',
  'pay.retry': '重新验证',
  'pay.cancel': '取消',
  'pay.success': '支付成功！',

  // AI Generation (aiPic)
  'aipic.back': '返回工作台',
  'aipic.title': 'AI渲染',
  'aipic.credits': '{0}积分',
  'aipic.refImages': '参考图片（最多3张）',
  'aipic.imageNo': '图{0}',
  'aipic.prompt': '提示词',
  'aipic.promptPlaceholder': '请输入描述图片内容的提示词...',
  'aipic.templates': '提示词模板',
  'aipic.generating': '生成中...',
  'aipic.generate': '生成图片 （',
  'aipic.cost': '6积分）',
  'aipic.result': '生成结果',
  'aipic.download': '下载',
  'aipic.enterPrompt': '请输入提示词',
  'aipic.success': '生成图片成功',
  'aipic.fail': '生成图片失败',
  'aipic.retryLater': '生成图片失败，请重试',
  'aipic.template.realistic': '超真实',
  'aipic.template.ghibli': '吉卜力风',
  'aipic.template.anime': '动漫',
  'aipic.template.pixar': 'Pixar 3D',
  'aipic.template.gamecg': '游戏CG',
  'aipic.template.oil': '油画',
  'aipic.template.chinese': '国风',
  'aipic.template.storybook': '儿童绘本',

  // Help modal
  'help.title': '帮助支持',
  'help.wechat': '微信号：',
  'help.copy': '复制',
  'help.email': '邮箱：',
  'help.sendEmail': '发送邮件',
  'help.copied': '微信号已复制',
  'help.copyFailed': '复制失败',

  // Group QR modal
  'qr.title': '添加微信群领取积分',
  'qr.tip': '扫描上方二维码添加客服微信，领取20积分',
  'qr.gotIt': '我知道了',

  // Community modal
  'community.title': '加入 Samelab\n创作者社区',
  'community.desc': '与 AI 创作者交流、分享作品、获取产品更新，并直接与 Samelab 团队沟通。',
  'community.benefit1': '认识更多 AI 创作者',
  'community.benefit2': '分享作品与创作流程',
  'community.benefit3': '获取产品更新与抢先体验',
  'community.benefit4': '直接与 Samelab 团队交流',
  'community.reward': '+20 AI 点数',
  'community.rewardDesc': ' · 加入社区后获得',
  'community.qrTitle': '使用微信扫码加入',
  'community.qrFooter': '加入 Samelab 社区\n与我们保持联系',
  'community.later': '以后再说',

  // VIP benefits table
  'benefits.header': '权益',
  'benefits.basic': '基础版',
  'benefits.pro': '专业版',
  'benefits.giftCredits': '赠送积分',
  'benefits.giftCreditsVip': '积分赠送',
  'benefits.animation': '动画编辑与时间轴功能',
  'benefits.notSupported': '免费10秒',
  'benefits.supported': '不限时长',
  'benefits.storage': '云存储空间',
  'benefits.hdExport': '高清图片导出',
  'benefits.hdExportNormal': '普通画质',
  'benefits.hdExportVip': '高清',

  // Material library (My Assets)
  'material.title': '个人素材库管理',
  'material.storage': '存储空间',
  'material.used': '已用',
  'material.total': '总计',
  'material.free': '可用',
  'material.upload': '上传素材',
  'material.uploadDesc': '支持 FBX / OBJ / GLB',
  'material.settings': '设置',
  'material.delete': '删除',
  'material.deleteConfirm': '确定要删除「{0}」吗？',
  'material.deleting': '删除中',
  'material.count': '共 {0} 个素材',
  'material.deleteFailed': '删除失败，请重试',

  // Import model confirm
  'import.title': '模型导入确认',
  'import.tips': '左键拖动旋转视角 · 滚轮缩放',
  'import.info': '模型信息',
  'import.fileName': '文件名：',
  'import.fileType': '文件类型：',
  'import.fileSize': '文件大小：',
  'import.scale': '缩放比例：',
  'import.modelSize': '模型尺寸：',
  'import.meshCount': '网格数量：',
  'import.addToLibrary': '添加到个人素材库',
  'import.confirm': '确认导入',
  'import.importing': '确认导入中',
  'import.uploading': '正在上传到个人素材库',
  'import.spaceInsufficient': '个人素材库空间不足，当前空间{0}，已用空间{1}，总空间{2}',

  // Publish model modal
  'publish.title': '公开模型',
  'publish.name': '模型名称',
  'publish.namePlaceholder': '请输入模型名称',
  'publish.isPublic': '是否公开到公开模型库',
  'publish.public': '公开',
  'publish.private': '不公开',
  'publish.publicTip': '公开后其他用户可以使用',
  'publish.price': '收费价格（积分）',
  'publish.priceTip': '公开后其他用户使用需付费，最多 100 积分，0 表示免费',
  'publish.category': '公开后所属分类',
  'publish.selectCategory': '请选择分类',
  'publish.other': '其他',
  'publish.scale': '缩放尺寸',
  'publish.scaleTip': '拖动滑块，右侧预览模型实时缩放',
  'publish.saving': '提交中...',
  'publish.modelLoading': '模型加载中...',
  'publish.previewTips': '左键拖拽旋转 · 滚轮缩放 · 坐标轴刻度 1 单位 = 1cm',
  'publish.noFile': '该素材缺少模型文件，无法预览',
  'publish.loadFailed': '模型加载失败，请重试',
  'publish.nameRequired': '请输入模型名称',
  'publish.categoryRequired': '请选择分类',
  'publish.scaleInvalid': '请输入有效的缩放尺寸（大于 0）',
  'publish.saveFailed': '公开失败，请重试',

  // Timeline
  'timeline.title': '时间轴',
  'timeline.stop': '停止',
  'timeline.record': '录制',
  'timeline.speed': '倍速',
  'timeline.object': '对象',
  'timeline.activeCamera': '激活摄像机',
  'timeline.cameraNo': '{0}号摄像机',
  'timeline.upgradeVip': '升级VIP解锁更长时长',
  'timeline.noRecordContent': '时间轴没有可录制的内容',
  'timeline.noCamera': '必须设置至少一个摄像机才可以录制',
  'timeline.recordEmpty': '录制内容为空，请重试',
  'timeline.recordDone': '录制完成',
  'timeline.recordDoneInfo': '录制完成（{0}），视频大小：{1} MB',
  'timeline.upgradeVipPlay': '升级VIP解锁更长时长播放功能',
  'timeline.recordFail': '导出录制视频失败',
  'timeline.browserNoRecord': '当前浏览器不支持视频录制',
  'timeline.recordError': '录制过程出错',
  'timeline.deleteNode': '删除节点',
}

export default zh
